import { useEffect, useState } from 'react';
import {
  getMsUntilScheduledDowntimeChange,
  getScheduledDowntimePhase,
  type ScheduledDowntimePhase,
} from '@/helpers/scheduledDowntime';

const MAX_TIMEOUT_MS = 2_147_483_647;

export const useScheduledDowntime = () => {
  const [phase, setPhase] = useState<ScheduledDowntimePhase>(() =>
    getScheduledDowntimePhase(),
  );

  useEffect(() => {
    const update = () => {
      setPhase(getScheduledDowntimePhase());
    };

    update();

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const schedule = () => {
      const ms = getMsUntilScheduledDowntimeChange();
      if (ms === null) {
        return;
      }

      timeoutId = setTimeout(
        () => {
          update();
          schedule();
        },
        Math.max(0, Math.min(ms, MAX_TIMEOUT_MS)),
      );
    };

    schedule();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        update();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return {
    phase,
    isActive: phase === 'active',
  };
};
